document.addEventListener('DOMContentLoaded', () => {

    function onScroll() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const footerOffset = document.getElementById('vijn-footer-section').offsetTop;
    
        if (scrollTop + windowHeight > footerOffset) {
            document.body.classList.add('footer-in-view');
        } else {
            document.body.classList.remove('footer-in-view');
        }
    }
    
    // Attach the function to scroll and resize events
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    
    // Initial check on load
    onScroll();

});